import { BROADCAST_TOGGLE_VIDEO_ACTIVE } from 'actions/Types';

function isVideoActive(state = true, action) {
  if (action.type === `${BROADCAST_TOGGLE_VIDEO_ACTIVE}_SUCCESS`) {
    return action.payload.isVideoActive;
  }

  return state;
}

export default isVideoActive;
